export default __webpack_public_path__ + "static/media/eventsOrFilming.e1ad0a22.png";